<template>
	<v-dialog v-model="dialog" max-width="500">
		<v-card class="pa-6">
			<div class="d-flex justify-space-between align-center mb-5">
				<v-card-title
					class="text-h6 grey--text text--darken-2 pa-0"
				>
					Cofnij prośbę o dołączenie
				</v-card-title>
				<v-btn @click="dialog = false" icon>
					<v-icon>mdi-close </v-icon>
				</v-btn>
			</div>
			<v-card-text
				class="mb-6 pa-0 subtitle-1 grey--text text--darken-2"
			>
				Czy na pewno cofnąć prośbę o dołączenie?
			</v-card-text>
			<v-card-actions class="d-flex justify-center">
				<v-btn
					color="grey lighten-4"
					elevation="0"
					@click="hideModal(false)"
					class="mr-2"
				>
					Anuluj
				</v-btn>
				<v-btn
					color="accent"
					elevation="0"
					@click="hideModal(true)"
				>
					Tak, cofnij prośbę o dołączenie
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {mapActions} from "vuex";

export default {
	name: "GroupJoinAskCancelModal",
	props: {
		groupId: {
			type: Number,
			required: true
		}
	},
	data() {
		return {
			dialog: false,
		}
	},
	methods: {
		...mapActions('groups', [
			'cancelRequestGroup'
		]),
		showModal () {
			this.dialog = true
		},
		hideModal (cancel) {
			if (cancel) {
				this.cancelRequestGroup({ id: this.groupId })
			}
			this.dialog = false
		}
	}
}
</script>

<style scoped>

</style>
